import { useState } from "react";
import { ApiService } from "@src/shared/api/apiService";
import { API } from "./api";
import { ISearchResult } from "../types/types";

export const useSearchResult = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [items, setItems] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  const limit = 10;

  const getSearchResult = async (pageNumber = 1, append = false) => {
    const offset = (pageNumber - 1) * limit;
    setIsLoading(true);

    try {
      const params = `offset=${offset}&limit=${limit}`;
      const res = await ApiService.get<ISearchResult>(
        API.GET_COLD_MATCHING_RESULTS(params)
      );

      setTotal(res.data.pagination.total);
      setPage(pageNumber);

      if (append) {
        setItems((prev) => [...prev, ...res.data.items]);
      } else {
        setItems(res.data.items);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    items,
    total,
    page,
    limit,
    isLoading,
    getSearchResult,
  };
};
